'use client';

import { useStore } from '@/store/store';

/**
 * Web Vitals Debug Section
 *
 * Provides controls for Web Vitals monitoring in development:
 * - Toggle resource monitor (logs slow resources and queueing to console)
 *
 * Note: Core Web Vitals tracking is always active.
 * The resource monitor is optional and controlled by this toggle.
 */
export const WebVitalsDebug = () => {
    const debug = useStore((s) => s.debug);

    return (
        <section className="debug-section">
            <h3>Web Vitals Monitoring</h3>
            <div className="debug-controls">
                <label className="debug-toggle">
                    <input
                        type="checkbox"
                        checked={debug.resourceMonitorEnabled}
                        onChange={() => debug.toggleResourceMonitor()}
                    />
                    <span className="toggle-label">
                        <span className="toggle-icon">👀</span>
                        Enable Resource Monitor
                    </span>
                </label>
                <p className="debug-hint">Logs slow resources (&gt;1s) and high queueing (&gt;100ms) to console</p>
            </div>
            <div className="debug-info">
                <p className="info-text">
                    <strong>Always Active:</strong> Core Web Vitals (LCP, FID, INP, CLS, FCP, TTFB)
                </p>
                <p className="info-text">
                    <strong>Next.js Metrics:</strong> Hydration, Route Changes, Renders
                </p>
                <p className="info-text">
                    <strong>Datadog:</strong> All metrics sent to RUM automatically
                </p>
            </div>
        </section>
    );
};
